<template>
  <div>
    <form id="externalForm" class="request-form">
      <header class="form__heading" data-anim>
        <UiTypography
          :tag="headingTag"
          variant="header01"
          class="form__title anim anim-opacity-1"
        >
          {{ title }}
        </UiTypography>

        <div class="form__contacts anim anim-opacity-2">
          <UiTypography tag="p" variant="caption" class="form__subtitle">
            Заполните форму или свяжитесь удобным способом
          </UiTypography>

          <div class="form__contact-links">
            <div class="form__contact-row">
              <UiTextButton
                variant="text-static"
                class="form__link"
                :href="whatsappLink"
                target="_blank"
                rel="noopener noreferrer"
                @click="waClick"
              >
                WhatsApp
              </UiTextButton>
              <UiTextButton
                variant="text-static"
                class="form__link"
                :href="maxLink"
                target="_blank"
                rel="noopener noreferrer"
                @click="trackTelegramEvent('max'); openExternal($event, maxLink)"
              >
                Max
              </UiTextButton>
              <UiTextButton
                variant="text-static"
                class="form__link"
                :href="telegramLink"
                target="_blank"
                rel="noopener noreferrer"
                @click="trackTelegramEvent('telegram'); openExternal($event, telegramLink)"
              >
                Telegram
              </UiTextButton>
            </div>
            <div class="form__contact-row">
              <UiTextButton
                variant="text-static"
                class="form__link"
                href="tel:+74951459252"
              >
                +7 (495) 145-92-52
              </UiTextButton>
              <UiTextButton
                variant="text-static"
                class="form__link"
                href="mailto:artplay@lithiumhome.ru"
              >
                Artplay@lithiumhome.ru
              </UiTextButton>
            </div>
          </div>
        </div>
      </header>

      <div id="form" class="form__fields">
        <input
          type="text"
          id="email"
          name="email"
          v-model="honeypot"
          tabindex="-1"
          autocomplete="new-password"
          aria-hidden="true"
          class="form__honeypot"
        />
        <div
          class="form__field"
          :class="{ 'is-invalid': !nameCheck && !firstCheck }"
        >
          <div class="form__field-row">
            <input
              placeholder="Ваше имя*"
              class="form__control"
              type="text"
              id="name"
              v-model="name"
              :class="{ 'is-invalid': !nameCheck && !firstCheck }"
            />
            <span v-if="!nameCheck && !firstCheck" class="form__error"
              >Заполните поле</span
            >
          </div>
        </div>
        <div
          class="form__field"
          :class="{ 'is-invalid': !numberCheck && !firstCheck }"
        >
          <div class="form__field-row form__field-row--phone">
            <input
              ref="phone"
              id="phone"
              type="tel"
              class="form__control"
              :placeholder="phoneFocused ? currentMask : 'Номер телефона*'"
              @focus="initPhone"
              @input="formatPhone"
              @blur="validatePhone"
              :class="{ 'is-invalid': !numberCheck && !firstCheck }"
              required
            />
            <span v-if="!numberCheck && !firstCheck" class="form__error"
              >Заполните поле</span
            >
          </div>
        </div>
        <div
          class="form__field"
          :class="{ 'is-invalid': !cityCheck && !firstCheck }"
        >
          <div class="form__field-row form__field-row--select">
            <select
              class="form__control"
              id="city"
              v-model="city"
              required
              :class="{ 'is-invalid': !cityCheck && !firstCheck }"
            >
              <option value="город" disabled hidden selected>Город*</option>
              <option value="403925">
                Москва
              </option>
              <option value="424327">
                Киров
              </option>
              <option value="449743">
                Другой
              </option>
            </select>
            <span v-if="!cityCheck && !firstCheck" class="form__error"
              >Заполните поле</span
            >
          </div>
        </div>

        <div
          class="form__field"
          :class="{ 'is-invalid': !authorTypeCheck && !firstCheck }"
        >
          <div class="form__field-row form__field-row--select">
            <select
              class="form__control"
              id="author"
              v-model="authorType"
              required
              :class="{ 'is-invalid': !authorTypeCheck && !firstCheck }"
            >
              <option value="" disabled hidden selected>
                Клиент / Дизайнер*
              </option>
              <option value="365641">Клиент</option>
              <option value="365643">Дизайнер</option>
              <option value="455837">Архитектор</option>
            </select>
            <span v-if="!authorTypeCheck && !firstCheck" class="form__error"
              >Заполните поле</span
            >
          </div>
        </div>
      </div>

      <div class="form__upload">
        <input
          name="project_uploads"
          id="project_uploads"
          type="file"
          multiple
          accept="image/*,video/*,.pdf,.zip,.rar,.7z"
          class="form__file-input"
          @change="show_file"
        />
        <UiTextButton
          tag="label"
          variant="text-icon"
          class="form__upload-button"
          for="project_uploads"
        >
          {{ fileInputText }}
        </UiTextButton>
        <UiTypography v-if="files.length" tag="span" variant="small">
          Загружено файлов: {{ files.length }}
        </UiTypography>
        <p v-if="fileError" class="form__file-error">
          {{ fileError }}
        </p>
      </div>

      <div class="form__actions">
        <label class="form__consent">
          <input
            type="checkbox"
            id="personal_data_checkbox"
            name="personal_data_checkbox"
            v-model="checkbox"
            class="form__consent-input"
            required
          />
          <UiTextButton
            tag="span"
            variant="text-checkbox"
            :active="checkbox"
            :class="{ 'is-invalid': !checkboxCheck && !firstCheck }"
          >
            <span class="form__consent-text">
              Я подтверждаю, что ознакомился с
              <router-link to="/policy"
                >политикой конфиденциальности</router-link
              >
              в отношении обработки персональных данных.
            </span>
          </UiTextButton>
        </label>

        <UiOutlineButton type="submit" @click="send_totp">
          Отправить
        </UiOutlineButton>
      </div>
    </form>
    <!-- <div ref="form" data-anim class="form-inner anim anim-opacity-3" /> -->
    <!--Modal window-->
    <div class="hystmodal" id="myModal" aria-hidden="true">
      <div class="hystmodal__wrap">
        <div class="hystmodal__window" role="dialog" aria-modal="true">
          <button data-hystclose class="hystmodal__close">Закрыть</button>
          <!--Modal window layout-->
          <div class="form-modal">
            <div data-anim class="isEntered" v-if="!modalError">
              <UiTypography tag="h2" variant="header02" class="form-modal__title anim anim-opacity-1">
                ПОДТВЕРДИТЕ ЗАЯВКУ
              </UiTypography>
              <UiTypography tag="p" variant="caption" class="form-modal__text anim anim-opacity-2">
                Подтвердите свой телефон для более быстрой обратной связи
              </UiTypography>
              <div id="otp" class="form-modal__otp">
                <input
                  class="form-modal__otp-input"
                  type="text"
                  pattern="\d*"
                  id="first"
                  autocomplete="one-time-code"
                  inputmode="numeric"
                  maxlength="1"
                />
                <input
                  class="form-modal__otp-input"
                  type="text"
                  pattern="\d*"
                  id="second"
                  autocomplete="one-time-code"
                  inputmode="numeric"
                  maxlength="1"
                />
                <input
                  class="form-modal__otp-input"
                  type="text"
                  pattern="\d*"
                  id="third"
                  autocomplete="one-time-code"
                  inputmode="numeric"
                  maxlength="1"
                />
                <input
                  class="form-modal__otp-input"
                  type="text"
                  pattern="\d*"
                  id="fourth"
                  autocomplete="one-time-code"
                  inputmode="numeric"
                  maxlength="1"
                />
                <input
                  class="form-modal__otp-input"
                  type="text"
                  pattern="\d*"
                  id="fifth"
                  autocomplete="one-time-code"
                  inputmode="numeric"
                  maxlength="1"
                />
                <input
                  class="form-modal__otp-input"
                  type="text"
                  inputmode="numeric"
                  pattern="\d*"
                  id="sixth"
                  autocomplete="one-time-code"
                  maxlength="1"
                />
              </div>
              <UiTypography tag="p" variant="caption" class="form-modal__text anim anim-opacity-2">
                {{ modalMessage }}
              </UiTypography>
              <div class="form-modal__actions">
                <UiOutlineButton id="check_button" type="button" @click="check_totp">
                  проверить
                </UiOutlineButton>
              </div>
            </div>
            <div data-anim class="isEntered" v-else>
              <UiTypography tag="h2" variant="header02" class="form-modal__title anim anim-opacity-1">
                Подтверждение недоступно
              </UiTypography>
              <UiTypography tag="p" variant="caption" class="form-modal__text anim anim-opacity-2">
                Не можем отправить заявку прямо сейчас
                <a
                  class="form-modal__link"
                  href="https://wa.me/74953245482"
                  @click="waClick2"
                  target="_blank"
                  >напишите нам в WhatsApp</a
                >
              </UiTypography>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal window success -->
    <div class="hystmodal" id="successWindow" aria-hidden="true">
      <div class="hystmodal__wrap">
        <div class="hystmodal__window" role="dialog" aria-modal="true">
          <button data-hystclose class="hystmodal__close">Закрыть</button>
          <!--Modal window layout-->
          <div class="form-modal" data-anim>
            <UiTypography tag="h2" variant="header02" class="form-modal__title anim anim-opacity-1">
              Ваша заявка будет обработана в приоритетном порядке
            </UiTypography>
            <UiTypography tag="p" variant="caption" class="form-modal__text anim anim-opacity-2">
              Спасибо за сотрудничество
            </UiTypography>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { trackTelegramEvent } from '@/utils/telegramPixel'
import { loadPhoneInput, loadFormModal } from '@/utils/formLibraries'
import anims from '@/mixins/anims'
import axios from 'axios'
import md5 from 'blueimp-md5'
import {
  UiOutlineButton,
  UiTextButton,
  UiTypography
} from '@/components/common/ui'

const axiosInstance = axios.create({
  baseURL: 'https://check.lithiumhome.ru/',
  withCredentials: true
})
axiosInstance.defaults.headers.post['Content-Type'] = 'application/json'

const axiosInstanceAmo = axios.create({
  baseURL: 'https://forms.amocrm.ru/',
  withCredentials: true
})
axiosInstanceAmo.defaults.headers.post['Content-Type'] = 'application/json'

const regexPhone = /^[7,8]9[0-9]{9}$/
const regexCode = /^[0-9]{6}$/

function autopaste (pasteValue, elem) {
  const evt = new Event('input')
  let siblingsCount = 1
  elem.value = pasteValue[0]
  let currentElem = elem.nextElementSibling
  elem.dispatchEvent(evt)
  while (currentElem) {
    currentElem.value = pasteValue[siblingsCount]
    siblingsCount += 1
    currentElem.dispatchEvent(evt)
    currentElem = currentElem.nextElementSibling
  }
}

export default {
  name: 'Form',

  components: {
    UiOutlineButton,
    UiTextButton,
    UiTypography
  },

  mixins: [anims],

  data () {
    return {
      modalMessage: 'Для авторизации введите код из СМС',
      fileInputDefaultText: 'Прикрепите файл с проектом ',
      fileInputText: 'Прикрепите файл с проектом',
      // Checkers
      firstCheck: true,
      checkboxCheck: false,
      nameCheck: false,
      numberCheck: true,
      cityCheck: false,
      firstForm: true,
      // Client number
      number: '',
      city: 'город',
      name: null,
      email: null,
      checkbox: null,
      modal: null,
      modalError: false,
      files: [],
      fileError: '',
      authorType: '',
      honeypot: '',
      iti: null,
      phoneFocused: false,
      authorTypeCheck: false,
      maskByCountry: {
        ru: '+7 (___) ___-__-__',
        kz: '+7 (___) ___-__-__',
        by: '+375 (___) ___-__-__',
        us: '+1 (___) ___-____',
        ca: '+1 (___) ___-____',
        gb: '+44 ____ ______',
        de: '+49 ____ ______',
        fr: '+33 _ __ __ __ __'
        // ... //
      },
      currentMask: '',
      sessionId: '',
      callValueTimer: null
    }
  },
  props: {
    headingTag: {
      type: String,
      default: 'h2',
      validator: value => ['h1', 'h2', 'h3'].includes(value)
    },
    title: {
      type: String,
      default: 'Подобрать комплектацию и получить расчёт'
    },
    extra: {
      type: String,
      default: ''
    }
  },

  computed: {
    startParameter () {
      return `${this.sessionId}_${this.extra}`
    },
    telegramLink () {
      const base = 'https://telegram.me/lithiumhome_bot'
      return this.extra
        ? `${base}?start=${encodeURIComponent(this.startParameter)}`
        : base
    },
    maxLink () {
      const base = 'https://max.ru/id4345414440_bot'
      return this.extra
        ? `${base}?start=${encodeURIComponent(this.startParameter)}`
        : base
    },
    whatsappLink () {
      if (!this.extra) return 'https://wa.me/74953245482'

      const text = `*Заявка №${this.startParameter}.* Просьба не удалять данную строку, она нужна для быстрого поиска вашего обращения.`
      return `https://api.whatsapp.com/send/?phone=74953245482&text=${encodeURIComponent(
        text
      )}&type=phone_number&app_absent=0`
    }
  },

  mounted () {
    if (this.extra) {
      this.syncCallValue()
      this.callValueTimer = window.setInterval(() => {
        if (this.syncCallValue()) {
          window.clearInterval(this.callValueTimer)
          this.callValueTimer = null
        }
      }, 100)
    }

    loadFormModal().then(() => {
      if (!this._isDestroyed) this.modal = new window.HystModal({})
    }).catch(error => console.warn(error.message))
    this.OTPInput()
  },

  beforeDestroy () {
    if (this.callValueTimer) {
      window.clearInterval(this.callValueTimer)
    }
    const el = this.$refs.phone
    if (el) {
      el.removeEventListener('countrychange', this.updatePhoneMask)
      el.removeEventListener('open:countrydropdown', this.positionCountryDropdown)
    }
    if (this.iti && typeof this.iti.destroy === 'function') {
      this.iti.destroy()
      this.iti = null
    }
  },

  methods: {
    trackTelegramEvent,
    openExternal (event, link) {
      if (!this.extra) return

      event.preventDefault()
      event.stopPropagation()
      window.open(link, '_blank', 'noopener')
    },
    syncCallValue () {
      if (!window.call_value) return false

      this.sessionId = window.call_value
      return true
    },
    initPhone () {
      this.phoneFocused = true
      const el = this.$refs.phone
      if (!el) return
      if (this.iti) {
        this.updatePhoneMask()
        this.formatPhone()
        return
      }
      if (this.phoneInitPromise) return this.phoneInitPromise

      this.phoneInitPromise = loadPhoneInput().then(() => {
        if (this._isDestroyed || this.$refs.phone !== el) return
        const wasFocused = document.activeElement === el
        this.iti = window.intlTelInput(el, {
          initialCountry: 'ru',
          preferredCountries: ['ru'],
          onlyCountries: ['ru', 'kz', 'by', 'us', 'ca', 'gb', 'de', 'fr'],
          separateDialCode: false,
          nationalMode: false,
          autoPlaceholder: 'polite',
          autoHideDialCode: false
        })

        // слушаем смену страны
        el.addEventListener('countrychange', this.updatePhoneMask)
        el.addEventListener('open:countrydropdown', this.positionCountryDropdown)
        this.updatePhoneMask()
        this.formatPhone()
        // The library reparents the input, which can blur it while typing.
        if (wasFocused) el.focus({ preventScroll: true })
      }).catch(error => console.warn(error.message)).finally(() => {
        this.phoneInitPromise = null
      })
      return this.phoneInitPromise
    },
    positionCountryDropdown () {
      if (window.innerWidth > 767) return

      const input = this.$refs.phone
      if (!input) return

      const rect = input.getBoundingClientRect()
      document.documentElement.style.setProperty(
        '--phone-country-top',
        `${rect.bottom}px`
      )
      document.documentElement.style.setProperty(
        '--phone-country-left',
        `${rect.left}px`
      )
      document.documentElement.style.setProperty(
        '--phone-country-width',
        `${rect.width}px`
      )
    },
    updatePhoneMask () {
      if (!this.iti) return
      const { iso2 } = this.iti.getSelectedCountryData()
      this.currentMask = this.maskByCountry[iso2] || '_______________'
      if (this.phoneFocused) {
        this.$refs.phone.setAttribute('placeholder', this.currentMask)
      }
      this.formatPhone()
    },

    formatPhone () {
      const el = this.$refs.phone
      if (!el || !this.iti) return
      const dial = this.iti.getSelectedCountryData().dialCode
      let digits = el.value.replace(/\D/g, '')
      if (dial && digits.startsWith(dial)) digits = digits.slice(dial.length)
      let out = ''
      let idx = 0
      for (const ch of this.currentMask) {
        if (idx >= digits.length) break
        out += ch === '_' ? digits[idx++] : ch
      }
      el.value = out
      this.validatePhone()
    },

    validatePhone () {
      if (!this.iti) {
        this.numberCheck = false
        return
      }
      const raw = this.iti.getNumber() // e.g. "+7..."
      const valid = this.iti.isValidNumber() // true/false
      console.log('TEL VALIDATE:', raw, valid)
      this.numberCheck = valid
      if (valid) {
        this.number = raw.replace(/\D/g, '')
      }
    },
    getFormattedPhone () {
      return this.iti ? this.iti.getNumber() : ''
    },
    send_totp: async function (event) {
      event.preventDefault()

      this.validatePhone()
      this.nameCheck = this.name && this.name.trim() !== ''
      this.cityCheck = !!this.city && this.city !== 'город'
      this.authorTypeCheck = !!this.authorType
      this.checkboxCheck = !!this.checkbox
      this.firstCheck = false

      this.nullify_modal()
      let form = document.getElementById('externalForm')
      form.checkValidity()
      this.firstCheck = false
      if (
        this.city != null &&
        this.city !== 'город' &&
        this.name != null &&
        this.name !== '' &&
        this.authorType &&
        this.numberCheck &&
        this.checkbox === true
      ) {
        if (this.number.startsWith('8')) {
          this.number = '7' + this.number.slice(1)
        }
        const formData = new FormData()
        const utmParams = JSON.parse(localStorage.getItem('utm_mas')) || {}
        const userOrigin = JSON.stringify({
          datetime: new Date(),
          referer: location.href
        })

        const path = window.location.pathname
        const isCeramics =
          path === '/ceramics' || path.startsWith('/ceramics/')
        const formConfig = isCeramics
          ? {
            form_id: '1531470',
            hash: '0155685b2d0945f918d769c5063126cc',
            visitor_uid: '898c9716-4764-4a8c-9ea1-05ff8e798395',
            fields: {
              phone: 'fields[184047_1][257901]',
              name: 'fields[name_1]',
              email: 'fields[727311_1]',
              email2: 'fields[727311_2]',
              authorType: 'fields[262583_1]',
              city: 'fields[701967_2]',
              privacy: 'fields[706643_1]'
            }
          }
          : {
            form_id: '1140670',
            hash: '1848e3b94db70f4de8dd912a5db1b168',
            visitor_uid: '898c9716-4764-4a8c-9ea1-05ff8e798394',
            fields: {
              phone: 'fields[184047_1][257901]',
              name: 'fields[name_1]',
              email: 'fields[727311_1]',
              email2: 'fields[727311_2]',
              authorType: 'fields[262583_1]',
              city: 'fields[701967_2]',
              privacy: 'fields[706643_1]'
            }
          }

        formData.append('form_id', formConfig.form_id)
        formData.append('hash', formConfig.hash)
        formData.append('visitor_uid', formConfig.visitor_uid)
        formData.append('gso_session_uid', this.generateGsoSessionUid())

        formData.append(formConfig.fields.phone, this.number) // phone
        // formData.append('phone', this.number)
        formData.append(formConfig.fields.name, this.name) // name
        formData.append(formConfig.fields.email, this.email) // email
        formData.append(formConfig.fields.email, this.email2) // email
        formData.append(
          formConfig.fields.authorType,
          this.authorType || 'не указан'
        ) // author type
        // formData.append('name', this.name)
        formData.append(formConfig.fields.city, this.city) // city
        formData.append(formConfig.fields.privacy, 'on') // privacy policy
        formData.append('user_origin', userOrigin)
        // formData.append('city', this.city)
        const utmMetrics = {
          ga: {},
          utm: { source: '', medium: '', content: '', campaign: '', term: '' },
          data_source: 'form'
        }
        if (utmParams.utm_source) {
          utmMetrics.utm.source = utmParams.utm_source
          formData.append('fields[280441_2]', utmParams.utm_source)
          // formData.append('utmSource', utmParams.utm_source)
        }
        if (utmParams.utm_campaign) {
          utmMetrics.utm.campaign = utmParams.utm_campaign
          formData.append('fields[280445_2]', utmParams.utm_source)
          // formData.append('utmCampgain', utmParams.utm_campaign)
        }
        if (utmParams.utm_medium) {
          utmMetrics.utm.campaign = utmParams.utm_campaign
          formData.append('fields[280443_2]', utmParams.utm_source)
          // formData.append('utmMedium', utmParams.utm_medium)
        }
        if (utmParams.utm_content) {
          utmMetrics.utm.content = utmParams.utm_content
          // formData.append('utmContent', utmParams.utm_content)
        }
        if (utmParams.utm_term) {
          utmMetrics.utm.term = utmParams.utm_term
          formData.append('fields[280447_2]', utmParams.utm_source)
          // formData.append('utmTerm', utmParams.utm_term)
        }
        if (utmParams.yclid || localStorage.getItem('_ym_uid')) {
          formData.append(
            'yclid',
            localStorage.getItem('_ym_uid') || utmParams.yclid
          )
        }
        formData.append('fields[716997_2]', JSON.stringify(utmMetrics))

        if (this.files.length > 0) {
          this.files.forEach((file) => {
            formData.append('fields[file_19]', file)
          })
        }
        if (this.firstForm) {
          try {
            const hash = md5(this.number.trim().replace(/\D/g, ''))
            localStorage.setItem('user_id', hash)
            console.log('send_totp: Save user_id')
            DSPCounter('send', {
              sid: '230574',
              site_area: '4czND8SX',
              user_id: hash,
              lead_id: '',
              order_sum: ''
            })
            console.log('send_totp: send DSPCounter')
          } catch (e) {
            console.warn('Ошибка при сохранении user_id:', e)
          }
          // this.firstForm = false
          await ym(88776155, 'reachGoal', 'application_form')
        }

        const formElements = `fields[name_1]=${
          this.name
        }&fields[184047_1][257901]=${this.number}&fields[701967_2]=${
          this.city
        }&fields[706643_1]=on&form_id=1140670&hash=1848e3b94db70f4de8dd912a5db1b168&&user_origin=${userOrigin}&fields[280441_2]=${
          utmMetrics.utm.source
        }&fields[280443_2]=${utmMetrics.utm.medium}&fields[280445_2]=${
          utmMetrics.utm.campaign
        }&fields[280447_2]=${
          utmMetrics.utm.term
        }&fields[716997_2]=${JSON.stringify(
          utmMetrics
        )}&visitor_uid=898c9716-4764-4a8c-9ea1-05ff8e798394`

        formData.append(
          'form_request_id',
          this.generateFormRequestId(formElements)
        )

        for (const [key, value] of formData.entries()) {
          console.log(`Key: ${key}, Value: ${value}`)
        }

        for (const [key, value] of formData.entries()) {
          console.log(`FormData: ${key} =>`, value)
        }
        this.sendToMailPhp()
        axiosInstanceAmo
          .post('/queue/add', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then((response) => {
            // this.modalError = false
            // this.modal.open('#successWindow')
            // console.log(response)
            _tmr.push({ type: 'reachGoal', id: 3563947, goal: 'lead_send' })
            try {
              const userId = localStorage.getItem('user_id') || ''
              DSPCounter('send', {
                sid: '230574',
                site_area: '4czND8SX',
                user_id: userId,
                lead_id: '',
                order_sum: ''
              })
            } catch (e) {
              console.warn('Ошибка при отправке события DSPCounter:', e)
            }
            this.finallyWindow()
          })
          .catch((error) => {
            console.error(error)
            // console.log(error)
            // this.modalError = true
            // this.modalError = false
            // this.modal.open('#myModal')
            // this.modal.open('#successWindow')
            _tmr.push({ type: 'reachGoal', id: 3563947, goal: 'lead_send' })
            this.finallyWindow()
          })
      }
      if (this.city == null || this.city === 'город') {
        this.cityCheck = false
      } else {
        this.cityCheck = true
      }
      if (this.name == null || this.name === '') {
        this.nameCheck = false
      } else {
        this.nameCheck = true
      }

      this.checkboxCheck = this.checkbox
      this.numberCheck = this.iti && this.iti.isValidNumber()
    },
    finallyWindow: function () {
      this.firstCheck = true
      this.city = 'город'
      this.name = ''
      this.authorType = ''
      this.checkbox = false
      this.number = ''
      this.files = []
      this.fileError = ''
      this.fileInputText = this.fileInputDefaultText
      this.nullify_modal()
      document.getElementById('project_uploads').value = ''
      this.$router.push('/applicationaccepted')
    },
    generateFormRequestId: function () {
      let e = 10
      void 0 === e && (e = 21)
      for (var t = '', o = crypto.getRandomValues(new Uint8Array(e)); e--;) {
        var n = 63 & o[e]
        t +=
          n < 36
            ? n.toString(36)
            : n < 62
              ? (n - 26).toString(36).toUpperCase()
              : n < 63
                ? '_'
                : '-'
      }
      return t
    },
    generateGsoSessionUid: function () {
      return crypto.randomUUID()
    },
    check_totp: function (event) {
      event.preventDefault()

      const inputs = document.querySelectorAll('#otp > *[id]')
      let content = ''
      inputs.forEach(function (event) {
        content = content + event.value
      })
      const userId = localStorage.getItem('user_id') || ''
      DSPCounter('send', {
        sid: '230574',
        site_area: '4czND8SX',
        user_id: userId,
        lead_id: '',
        order_sum: ''
      })
      console.log('check_totp: send DSPCounter')
      try {
        const userId = localStorage.getItem('user_id') || ''
        DSPCounter('send', {
          sid: '230574',
          site_area: '4czND8SX',
          user_id: userId,
          lead_id: '',
          order_sum: ''
        })
        console.log('check_totp: send DSPCounter')
      } catch (e) {
        console.warn('Ошибка при отправке события DSPCounter:', e)
      }

      if (regexPhone.exec(this.number) && regexCode.exec(content)) {
        this.modalMessage = 'Код проверяется...'
        axiosInstance
          .post('/api/validate', {
            phone: '' + this.number,
            code: content
          })
          .then((response) => {
            this.modal.close()
            // this.modal.open('#successWindow')
            this.firstCheck = true
            this.city = 'город'
            this.name = ''
            this.checkbox = false
            this.number = ''
            this.fileInputText = this.fileInputDefaultText
            this.nullify_modal()
            document.getElementById('project_uploads').value = ''
            this.$router.push('/applicationaccepted')
          })
          .catch((error) => {
            console.error(error)
            this.modalMessage =
              'Неверный код из СМС. Пожалуйста, введите код, который вы получили или проверьте корректность указанного номера телефона. '
          })
      } else {
        this.modalMessage = 'Код должен содержать 5 символов'
      }
    },
    show_file: function (event) {
      const selectedFiles = Array.from(event.target.files)
      const totalSize = selectedFiles.reduce((sum, file) => sum + file.size, 0)

      if (selectedFiles.length > 5) {
        this.fileError = 'Можно прикрепить не более 5 файлов.'
        this.files = []
        return
      }

      if (totalSize > 30 * 1024 * 1024) {
        this.fileError = 'Общий размер файлов не должен превышать 30 МБ.'
        this.files = []
        return
      }

      this.fileError = ''
      this.files = selectedFiles
    },
    OTPInput: function () {
      const inputs = document.querySelectorAll('#otp > *[id]')
      inputs[0].focus()
      for (let i = 0; i < inputs.length; i++) {
        inputs[i].addEventListener('keydown', function (event) {
          if (event.key === 'Backspace') {
            inputs[i].value = ''
            if (i !== 0) inputs[i - 1].focus()
            if (i !== 0) inputs[i - 1].select()
            event.preventDefault()
          }
        })
        inputs[i].addEventListener('paste', function (event) {
          autopaste(
            (event.clipboardData || window.clipboardData).getData('text'),
            event.target
          )
        })
        inputs[i].addEventListener('input', function (event) {
          if (event.target.value.length > event.target.maxLength) {
            autopaste(event.target.value, event.target)
            return
          }
          if (event.target.value !== '') {
            event.target.value = event.target.value.toString().toUpperCase()
            if (i !== inputs.length - 1) {
              inputs[i + 1].focus()
              inputs[i + 1].select()
            }
          }
        })
      }
    },
    nullify_modal: function () {
      this.modalError = false
      this.modalMessage = 'Для авторизации введите код из СМС'
      this.clear_modal_inputs()
      this.OTPInput()
    },
    clear_modal_inputs: function () {
      const inputs = document.querySelectorAll('#otp > *[id]')
      inputs.forEach((inpunt) => {
        inpunt.value = ''
      })
    },
    sendToMailPhp () {
      const formData = new FormData()
      formData.append('name', this.name || '')
      formData.append('email', this.email || 'noreply@domain.test')
      formData.append('email', this.honeypot || '')
      formData.append(
        'phoneNumber',
        this.iti ? this.iti.getNumber().replace(/\D/g, '') : ''
      )
      formData.append('city', this.city || '')
      formData.append('author', this.authorType || 'не указан')
      formData.append('subject', 'Заявка с формы')

      if (this.files && this.files.length > 0) {
        this.files.forEach((file) => {
          formData.append('project_uploads[]', file)
        })
      }

      axios
        .post('/mail.php', formData)
        .then((response) => {
          console.log('mail.php ответ:', response.data)
        })
        .catch((error) => {
          console.error('Ошибка отправки в mail.php:', error)
        })
    },
    waClick (event) {
      trackTelegramEvent('whatsapp')
      this.openExternal(event, this.whatsappLink)
      try {
        const userId = localStorage.getItem('user_id') || ''
        DSPCounter('send', {
          sid: '230574',
          site_area: 'w99MH4Ze',
          user_id: userId,
          lead_id: '',
          order_sum: ''
        })
        console.log('waClick: send DSPCounter')
      } catch (e) {
        console.warn('Ошибка DSPCounter WA:', e)
      }

      ym(88776155, 'reachGoal', 'clickwa')
      _tmr.push({ type: 'reachGoal', id: 3563947, goal: 'WA_click' })
    },

    waClick2 (event) {
      trackTelegramEvent('whatsapp')
      this.openExternal(event, this.whatsappLink)
      try {
        const userId = localStorage.getItem('user_id') || ''
        DSPCounter('send', {
          sid: '230574',
          site_area: 'w99MH4Ze',
          user_id: userId,
          lead_id: '',
          order_sum: ''
        })
        console.log('waClick2: send DSPCounter')
      } catch (e) {
        console.warn('Ошибка DSPCounter WA:', e)
      }
      ym(88776155, 'reachGoal', 'clickwa')
    }
  }
}
</script>

<style lang="scss">
html {
  scrollbar-gutter: stable;
}

html.hystmodal__opened {
  margin-right: 0 !important;
}

.iti__flag {
  background-image: url("/assets/lib/img/flags.png") !important;
}

.form__field-row--phone .iti {
  display: block;
  width: 100%;
  height: 100%;
  border: 0 !important;
  box-shadow: none !important;

  .iti__flag-container,
  .iti__selected-flag {
    height: 100%;
  }

  .iti__selected-flag {
    padding: 0 vw(8);
  }

  > #phone {
    padding-right: 0 !important;
    padding-left: vw(52) !important;
    border: 0 !important;
    border-top: 1px solid #cdcdcd;
    outline: 0 !important;
    box-shadow: none !important;
    text-indent: 0 !important;
  }

  @include max-width(mobile) {
    .iti__selected-flag {
      padding: 0 vwm(8);
    }

    > #phone {
      padding-left: vwm(52) !important;
    }
  }
}

@include max-width(mobile) {
  .iti-mobile .iti--container {
    box-sizing: border-box;
    position: fixed !important;
    top: var(--phone-country-top) !important;
    right: auto !important;
    bottom: auto !important;
    left: var(--phone-country-left) !important;
    width: var(--phone-country-width) !important;
    height: auto !important;
    padding: 0;
    background: #fff;
  }

  .iti-mobile .iti__country-list {
    width: 100%;
    max-height: min(50vh, vwm(320));
    border: 1px solid #cdcdcd;
    white-space: normal;
  }

  .iti-mobile .iti__country {
    display: flex;
    align-items: center;
    min-width: 0;
    padding: vwm(10);
    font: 400 vwm(12) / 1.3 "Helvetica", Arial, sans-serif;
  }

  .iti-mobile .iti__country-name {
    min-width: 0;
    overflow-wrap: anywhere;
  }
}
</style>
<style lang="scss" scoped>
.request-form {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: vw(120) vw(388);
  border-top: 1px solid #cdcdcd;
  border-bottom: 1px solid #cdcdcd;
  background: #f0f0f0;
  color: #2e2e2e;
}

.form {
  &__heading {
    display: flex;
    flex-direction: column;
    gap: vw(20);
    margin-bottom: vw(60);
  }

  &__contacts {
    display: flex;
    align-items: center;
    gap: vw(20);
  }

  &__subtitle {
    flex: 0 0 auto;
  }

  &__contact-links {
    display: flex;
    align-items: center;
    gap: vw(20);
  }

  &__contact-row {
    display: contents;
  }

  &__link {
    text-decoration: underline;
    text-underline-offset: vw(2);
  }

  &__fields {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: vw(20);
  }

  &__field-row {
    position: relative;
    height: 100%;
  }

  &__field {
    position: relative;
    box-sizing: border-box;
    height: vw(52);
    --field-line-color: #cdcdcd;

    &.is-invalid {
      --field-line-color: #8c0014;
    }
  }

  &__field::before,
  &__field:nth-of-type(n + 3)::after {
    content: "";
    position: absolute;
    right: 0;
    left: 0;
    z-index: 2;
    height: 1px;
    background: var(--field-line-color);
    pointer-events: none;
  }

  &__field::before {
    top: 0;
  }

  &__field:nth-of-type(n + 3)::after {
    bottom: 0;
  }

  &__honeypot {
    position: absolute;
    top: -9999px;
    left: -9999px;
    width: 1px;
    height: 1px;
    opacity: 0;
  }

  &__control {
    box-sizing: border-box;
    display: block;
    width: 100%;
    height: 100%;
    padding: vw(16) 0;
    border: 0 !important;
    border-radius: 0;
    outline: none;
    background: transparent;
    color: #2e2e2e;
    font: 400 vw(14) / 1.3 "Helvetica", Arial, sans-serif;
    appearance: none;

    &::placeholder {
      color: #2e2e2e;
      opacity: 1;
    }

  }

  select.form__control {
    padding-right: vw(28);
  }

  &__field-row--select::after {
    content: "";
    position: absolute;
    top: 50%;
    right: vw(4);
    width: vw(13);
    height: vw(7);
    background: url("/phone_supplement/arrow-d.svg") center / contain no-repeat;
    transform: translateY(-50%);
    pointer-events: none;
  }

  &__error {
    position: absolute;
    top: 50%;
    right: vw(4);
    color: #8c0014;
    font-size: vw(10);
    line-height: 1;
    transform: translateY(-50%);
  }

  &__field-row--select &__error {
    right: vw(32);
  }

  &__upload {
    display: flex;
    align-items: center;
    gap: vw(12);
    min-height: vw(29);
    margin-top: vw(20);
  }

  &__file-input,
  &__consent-input {
    position: absolute;
    width: vw(1);
    height: vw(1);
    overflow: hidden;
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    white-space: nowrap;
  }

  &__upload-button {
    cursor: pointer;
  }

  &__file-error {
    color: #8c0014;
    font-size: vw(12);
    line-height: 1.3;
  }

  &__actions {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: vw(20);
    margin-top: vw(60);
  }

  &__consent {
    display: block;
    width: 100%;
    cursor: pointer;
  }

  &__consent > .ui-text-button {
    align-items: center;
  }

  &__consent-text {
    text-transform: none;

    a {
      color: inherit;
      text-decoration: underline;
    }
  }

  &__consent .is-invalid {
    color: #8c0014;
  }
}

@include max-width(mobile) {
  .request-form {
    padding: vwm(64) vwm(18);
    border-width: 1px 0;
  }

  .form {
    &__heading {
      gap: vwm(20);
      margin-bottom: vwm(64);
    }

    &__contacts {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      gap: vwm(20);
    }

    &__contact-links {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      gap: vwm(12);
    }

    &__contact-row {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      width: 100%;
    }

    &__link {
      text-underline-offset: vwm(2);
    }

    &__fields {
      grid-template-columns: 1fr;
    }

    &__field {
      height: vwm(48);
    }

    &__field:nth-of-type(n + 3)::after {
      display: none;
    }

    &__field:last-child::after {
      display: block;
    }

    &__control {
      padding: vwm(15) 0;
      font-size: vwm(12);
    }

    select.form__control {
      padding-right: vwm(24);
    }

    &__field-row--select::after {
      right: vwm(4);
      width: vwm(11);
      height: vwm(6);
    }

    &__error {
      right: vwm(4);
      font-size: vwm(10);
    }

    &__field-row--select &__error {
      right: vwm(28);
    }

    &__upload {
      gap: vwm(10);
      min-height: vwm(17);
      margin-top: vwm(20);
    }

    &__file-input,
    &__consent-input {
      width: vwm(1);
      height: vwm(1);
    }

    &__file-error {
      font-size: vwm(10);
    }

    &__actions {
      gap: vwm(20);
      margin-top: vwm(32);
    }

    &__consent-text {
      display: inline-block;
      max-width: vwm(296);
    }

    &__consent > .ui-text-button {
      align-items: flex-start;
    }
  }
}

.form-modal {
  box-sizing: border-box;
  width: 100%;
  padding: vw(64);
  background: #f2f2f2;

  &__title,
  &__text {
    margin: 0;
  }

  &__text {
    margin-top: vw(20);
  }

  &__link {
    color: inherit;
    text-decoration: underline;
  }

  &__otp {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: vw(10);
    margin-top: vw(32);
  }

  &__otp-input {
    box-sizing: border-box;
    width: 100%;
    height: vw(49);
    padding: 0;
    border: 0;
    border-bottom: 1px solid #cdcdcd;
    border-radius: 0;
    outline: none;
    background: transparent;
    color: #2e2e2e;
    font: 400 vw(14) / 1.3 "Helvetica", Arial, sans-serif;
    text-align: center;

    &:focus {
      border-bottom-color: #8c0014;
    }
  }

  &__actions {
    display: flex;
    justify-content: center;
    margin-top: vw(32);
  }

  @include max-width(mobile) {
    padding: vwm(48) vwm(18);

    &__text {
      margin-top: vwm(20);
    }

    &__otp {
      gap: vwm(8);
      margin-top: vwm(28);
    }

    &__otp-input {
      height: vwm(48);
      font-size: vwm(12);
    }

    &__actions {
      margin-top: vwm(28);
    }
  }
}

// hystmodal code
.hystmodal__opened,
.hystmodal__shadow {
  position: fixed;
  right: 0;
  left: 0;
  overflow: hidden;
}

.hystmodal__shadow {
  border: none;
  display: block;
  width: 100%;
  top: 0;
  bottom: 0;
  pointer-events: none;
  z-index: 98;
  opacity: 0;
  transition: opacity 0.15s ease;
  background-color: #000;
}

.hystmodal__shadow--show {
  pointer-events: auto;
  opacity: 0.6;
}

.hystmodal {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  overflow: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  opacity: 1;
  background-color: rgba(0, 0, 0, 0.5);
  pointer-events: none;
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  z-index: 99;
  visibility: hidden;
}

.hystmodal--active {
  opacity: 1;
}

.hystmodal--active,
.hystmodal--moved {
  pointer-events: auto;
  visibility: visible;
}

.hystmodal__wrap {
  flex-shrink: 0;
  flex-grow: 0;
  width: 100%;
  min-height: 100%;
  margin: auto;
  opacity: 1;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
}

.hystmodal__window {
  margin: vw(50) 0;
  box-sizing: border-box;
  flex-shrink: 0;
  flex-grow: 0;
  background: #fff;
  width: vw(600);
  max-width: 100%;
  overflow: visible;
  transition: transform 0.2s ease 0s, opacity 0.2s ease 0s;
  transform: scale(0.9);
  opacity: 0;
}

.hystmodal--active .hystmodal__window {
  transform: scale(1);
  opacity: 1;
}

.hystmodal__close {
  position: absolute;
  z-index: 10;
  top: vw(20);
  right: vw(20);
  display: block;
  width: vw(30);
  height: vw(30);
  background-color: transparent;
  background-position: 50%;
  background-repeat: no-repeat;
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23fff' stroke='gray' stroke-linecap='square' stroke-miterlimit='50' stroke-width='2' d='M22 2L2 22'/%3E%3Cpath fill='none' stroke='gray' stroke-linecap='square' stroke-miterlimit='50' stroke-width='2' d='M2 2l20 20'/%3E%3C/svg%3E");
  background-size: 100% 100%;
  border: none;
  font-size: 0;
  cursor: pointer;
  outline: none;
}

.hystmodal__close:focus {
  outline: vw(2) dotted #afb3b9;
  outline-offset: vw(2);
}

@media (max-width: 767px) {
  .hystmodal__close {
    top: vwm(10);
    right: vwm(10);
    width: vwm(24);
    height: vwm(24);
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23fff' stroke='gray' stroke-linecap='square' stroke-miterlimit='50' stroke-width='2' d='M22 2L2 22'/%3E%3Cpath fill='none' stroke='gray' stroke-linecap='square' stroke-miterlimit='50' stroke-width='2' d='M2 2l20 20'/%3E%3C/svg%3E");
  }

  .hystmodal__window {
    margin: 0;
  }
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  margin: 0;
}
</style>
